import {fetchAndInsertVisual, fetchAndInsertTimeline} from './blogPostVisuals.js';

fetchAndInsertVisual("/stuff/2023-12-09-visual1.json?v1", "9d89fed0-92f4-11ee-bec3-daa4de339950", "cov-kernel", "cov-kernel-content", 0);
fetchAndInsertVisual("/stuff/2023-12-09-visual2.json?v1", "d8f79b18-93bb-11ee-89d6-daa4de339950", "cov-kernel2", "cov-kernel-content2", 0);
fetchAndInsertTimeline("/stuff/2023-12-09-visual3.json?v1", "e71ccb0e-970e-11ee-93a3-daa4de339950", "cov-kernel3", "cov-kernel-content3", 20);
